/**
 * Post-kiosk Tier-A lifecycle shells — onDisposed cancels token resolution queries (GC-P0-03).
 */
import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useTenantCode } from '../../../shared/tenant/TenantProvider.js';
import { ScreenLifecycle } from '../../../shared/screen/ScreenLifecycle.js';
import { PostKioskProductJourney } from '../PostKioskProductJourney.js';
import { PostKioskDonationJourney } from '../PostKioskDonationJourney.js';
import type { ReactNode } from 'react';

function useCancelTenantCustomerQueries(): () => void {
  const queryClient = useQueryClient();
  const tenantCode = useTenantCode();
  return useCallback(() => {
    void queryClient.cancelQueries({ queryKey: ['customer', tenantCode] });
  }, [queryClient, tenantCode]);
}

export function PostKioskProductJourneyLifecycle(): JSX.Element {
  const onDisposed = useCancelTenantCustomerQueries();
  return (
    <ScreenLifecycle screenId="MS-COM-038" onDisposed={onDisposed}>
      <PostKioskProductJourney />
    </ScreenLifecycle>
  );
}

export function PostKioskDonationJourneyLifecycle(): JSX.Element {
  const onDisposed = useCancelTenantCustomerQueries();
  return (
    <ScreenLifecycle screenId="MS-COM-039" onDisposed={onDisposed}>
      <PostKioskDonationJourney />
    </ScreenLifecycle>
  );
}

export function PostKioskResolverLifecycle({ children }: { children: ReactNode }): JSX.Element {
  const onDisposed = useCancelTenantCustomerQueries();
  return (
    <ScreenLifecycle screenId="MS-COM-033" onDisposed={onDisposed}>
      {children}
    </ScreenLifecycle>
  );
}
